import React, { ReactNode } from 'react'
import styles from './styles.module.scss'

interface IProps {
  header: {
    title: string
    buttonFunc?: any
    buttonTitle?: string
    icon?: string
    searchFunc?: any
    actions?: ReactNode
  }
  children: any
}

export const GenericContentPage: React.FC<IProps> = (props: IProps) => {
  const { title, buttonFunc, buttonTitle, icon, searchFunc, actions } = props.header

  return (
    <>
      <div className={styles.pageHeader}>
        <h3 className={styles.pageTitle}>{title}</h3>
        <div className={styles.pageActions}>
          {searchFunc && buttonTitle ? (
            <input
              className={styles.searchInput}
              type="search"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                searchFunc(e.target.value)
              }}
            />
          ) : null}
          {actions}
          {buttonTitle ? (
            <button
              className="addButton"
              type="button"
              onClick={() => {
                buttonFunc(true)
              }}
            >
              <img className="addButtonIcon" src={icon} alt="" />
              {buttonTitle}
            </button>
          ) : null}
        </div>
      </div>
      {props.children}
    </>
  )
}

export default GenericContentPage
